import { GtoLogo } from '../brand/Logo';
import { Yarlyk } from '../brand/Yarlyk';
import { BrandFrame } from '../brand/BrandFrame';
import { Icon } from '../components/Icon';
import './LeftScreen.css';

export function LeftScreen({
  code,
  reason,
  message,
  onRejoin,
  onHome,
}: {
  code: string;
  reason: 'user' | 'error';
  message?: string;
  onRejoin: () => void;
  onHome: () => void;
}) {
  const failed = reason === 'error';

  return (
    <div className="left">
      <div className="grid-bg" />
      <div className="aura left__aura" />

      <div className="left__box">
        <BrandFrame inset={-16} />

        <Yarlyk side="bottom" tone={failed ? 'danger' : 'accent'}>
          {failed ? 'Соединение прервано' : 'Встреча завершена'}
        </Yarlyk>

        <h1 className="left__title">
          {failed ? 'СВЯЗЬ\nПОТЕРЯНА' : 'ВЫ ВЫШЛИ\nИЗ ВСТРЕЧИ'}
        </h1>

        <p className="left__text">
          {failed
            ? (message ?? 'Соединение с медиасервером прервалось.') +
              ' Попробуйте вернуться — комната остаётся активной ещё пятнадцать минут.'
            : 'Комната остаётся активной ещё пятнадцать минут — можно вернуться по той же ссылке.'}
        </p>

        <p className="left__code mono-code">{code}</p>

        <div className="left__actions">
          <button type="button" className="btn btn--primary btn--lg" onClick={onRejoin}>
            <Icon name="refresh" />
            Вернуться во встречу
          </button>
          <button type="button" className="btn btn--ghost btn--lg" onClick={onHome}>
            <Icon name="logout" />
            На главную
          </button>
        </div>
      </div>

      <footer className="left__footer">
        <GtoLogo height={22} />
      </footer>
    </div>
  );
}
